import ProductFooter from "./ProductFooter";

export default ProductFooter;
